import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

import LoadingIndicator from "../../components/LoadingIndicator";
import {
  useQueryGetClient,
  useQueryGetModelVersions,
} from "../../data/services/clientService";

const SUBMITTED_STATUSES = new Set([
  "Submitted",
  "PublishInProgress",
  "PublishError",
  "Published",
  "PublishedDefault",
]);

const getTargetVersionId = (client, modelVersions) => {
  if (!client || !Array.isArray(modelVersions) || modelVersions.length === 0) {
    return null;
  }

  if (SUBMITTED_STATUSES.has(client.oeStatus) && client.submittedVersionId) {
    return client.submittedVersionId;
  }

  const clientDefaultVersion = modelVersions.find(
    (version) => version.isClientDefault === true,
  );

  if (clientDefaultVersion) {
    return clientDefaultVersion.modelVersionId;
  }

  const firstNonSystemVersion = modelVersions.find(
    (version) => version.isSystem !== true,
  );

  return firstNonSystemVersion?.modelVersionId ?? null;
};

const ClientFSARedirect = () => {
  const { clientId, oePeriodId } = useParams();
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin/");
  const routePrefix = isAdminRoute ? "/admin" : "";

  const { isLoading: clientLoading, data: clientResponse } = useQueryGetClient(
    oePeriodId,
    clientId,
  );
  const { isLoading: modelVersionsLoading, data: modelVersionsResponse } =
    useQueryGetModelVersions(oePeriodId, clientId);

  if (clientLoading || modelVersionsLoading) {
    return <LoadingIndicator />;
  }

  const client = clientResponse?.data ?? null;
  const modelVersions = modelVersionsResponse?.data ?? [];
  const targetVersionId = getTargetVersionId(client, modelVersions);

  if (targetVersionId) {
    return (
      <Navigate
        replace
        to={`${routePrefix}/clients/${clientId}/oe/${oePeriodId}/ratemodel/${targetVersionId}?tab=FSA`}
      />
    );
  }

  return (
    <Navigate
      replace
      to={`${routePrefix}/clients/${clientId}/oe/${oePeriodId}/summary`}
    />
  );
};

export default ClientFSARedirect;